import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    postings: {
      selectIds: [],
      filters: {},
      selectId: false
    }
  },
  mutations: {
    SET_POSTING_SELECT_IDS (store, ids) {
      store.postings.selectIds = ids
    },
    REMOVE_POSTING_SELECT_IDS (store, ids) {
      store.postings.selectIds = store.postings.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_POSTING_SELECT_ID (store, id) {
      store.postings.selectId = id
    },
    SET_POSTING_FILTERS (store, filters) {
      store.postings.filters = filters
    }
  },
  getters: {
    getPostings: (store, getters) => {
      return store.postings.selectIds.map((id) => {
        return getters['entities/postings/find'](id)
      })
    },
    getPostingsFilters: (store, getters) => {
      return store.postings.filters
    },
    getPosting: (store, getters) => {
      return getters['entities/postings/find'](store.postings.selectId) || {}
    }
  },
  actions: {
    /*
    selectPostings
    */
    selectPostings ({commit, dispatch, getters, state}, filters) {
      return dispatch('getPostings', filters)
      .then((response) => {
        commit('SET_POSTING_FILTERS', filters)
        commit('SET_POSTING_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectPostings
    */
    refreshSelectPostings ({commit, dispatch, getters, state}) {
      return dispatch('selectPostings', getters.getPostingsFilters)
    },
    /*
    selectPosting
    */
    selectPosting ({commit, dispatch, getters, state}, id) {
      return dispatch('getPostingById', id)
      .then((response) => {
        commit('SET_POSTING_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getPostings
    */
    getPostings ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/postings`, {params: filters})
      .then((response) => {
        return dispatch('entities/postings/insert', {
          data: response.data
        })
        .then((result) => {
          return result.postings || []
        })
      })
    },
    /*
    getPostingById
    */
    getPostingById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/postings/${id}`)
      .then((response) => {
        return dispatch('entities/postings/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.postings[0]
      })
    },
    /*
    createPosting
    */
    createPosting ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/postings`, data)
      .then((response) => {
        return dispatch('entities/postings/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.postings[0]
      })
    },
    /*
    updatePosting
    */
    updatePosting ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/postings/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/postings/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.postings[0]
      })
    },
    /*
    deletePosting
    */
    deletePosting ({commit, dispatch, getters, state}, {id, job_board}) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/postings/${id}`)
      .then((response) => {
        commit('REMOVE_POSTING_SELECT_IDS', [id])
        dispatch('entities/postings/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Posting.js